<template>
  <v-dialog max-width="1000px" @click:outside="closeModal()">
    <v-card class="h-auto bg-white font-inter">
      <div class="pt-3 bg-slate-100">
        <div class="flex justify-between items-center pb-2 px-3">
          <h4 class="font-bold text-lg">Preview File Keabsahan</h4>
          <v-btn
            variant="outlined"
            class="capitalize text-xs w-28 border-gray-400 bg-slate-100"
            @click="closeModal"
          >
            <span class="text-gray-500"> Close </span>
          </v-btn>
        </div>
      </div>
      <iframe
        v-if="previewUrl"
        :src="previewUrl"
        width="100%"
        height="700px"
        style="border: none"
      ></iframe>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PreviewModal",
  props: {
    previewUrl: String,
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>
